<template>
	<el-dialog :visible="show" append-to-body title="分类设置" :close-on-click-modal="false" width="500px" @close="closeDialog">
		<el-form ref="vForm" label-width="80px" :model="vForm">
			<el-form-item label="名称" prop="name" :rules="{ required: true, message: '名称必填' }">
				<el-input v-model="vForm.name"></el-input>
				<div class="v-form-tips">全部分类名称</div>
			</el-form-item>
			<el-form-item label="图标" prop="name" :rules="{ required: true, message: '名称必填' }">
				<v-upload-image v-model="vForm.icon" type="preview" width="100px" height="100px" @change="$refs.vForm.validateField('icon')" />
				<div class="v-form-tips">全部分类图标</div>
			</el-form-item>
			<el-form-item label="背景颜色">
				<el-color-picker v-model="vForm.bgColor"></el-color-picker>
				<div class="v-form-tips">电脑端（手机端）筛选按钮背景颜色</div>
			</el-form-item>
			<el-form-item label="文字颜色">
				<el-color-picker v-model="vForm.txtColor"></el-color-picker>
				<div class="v-form-tips">电脑端筛选按钮图标及文字颜色</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">
				确 定
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import configPage from "@/assets/js/configPage";

	export default {

		props: {
			show: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				doSubmitLoading:false,
				name: 'category',
				vForm: {
					name:'',
					icon: '',
					bgColor:'',
					txtColor:''
				}
			}
		},

		created() {
			this.getOption();
		},

		methods: {

			closeDialog() {
				this.$emit('update:show', false);
			},

			async getOption() {
				this.loading = true;
				try {
					let res = await this.api.option.get({name: this.name});
					if(res && res.data){
						Object.assign(this.vForm,res.data)
					}else{
						Object.assign(this.vForm,configPage.category)
          }
				} catch (e) {
					console.error(e)
				}
				this.loading = false;
			},

			//提交表单
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api.option.set({name: this.name, option: this.vForm});
					this.$emit("success");
					this.$message.success('更新成功');
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			}
		}
	}
</script>